import React from 'react';
import {
    ContenedorForm,
    HeaderForm,
    CuerpoForm,
    TituloForm,
    Row,
    ContainerCol
} from '../../componentes_generales/componentes_formulario/contenedores';
import {LabelForm} from "../../componentes_generales/componentes_formulario/labels";
import InputSearch from "../../componentes_generales/componentes_formulario/inputs/inputsearch";
import TablaArticulos from "./tabla_articulos.component";
import ReactSelectAsync from "../../componentes_generales/componentes_formulario/selects/react-select-async";
import Tooltip from "rc-tooltip";

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../../actions/generales/act_gen03';
import { cambiar_VisualizacionLoading } from '../../../actions/generales/act_gen01';
import {
    cargarProformasAEncartonarPorCliente, cambiarEstadoDeProformaEncartonada, resetProformasAEncartonar,
    cargarItemsAEncartonarPorProforma, eliminarItemsAEncartonarPorProforma, actualizarErroresDeValidacionDeItem,
    resetItemsAEncartonar, actualizarPesoDeCarton, actualizarFlagPesoAutomatico, guardarEncartonado, cargarEncartonado,
    anularEncartonado, setEncartonadoId, setEncartonadoObservacion, setEncartonadoFecha, actualizarCodUltimoCarton
} from "../../../actions/ventas/act_ven26";
import {
    esNumero,
    validarCampoString,
    validarJSON,
    validarPermisoAcceso,
    validarStringConAnchoMinimo
} from "../../../funciones_globales/utils";
import {getFechaProcesoPorModulo, getItemDatosSesion} from "../../../funciones_globales/manejosesion";
import {visualizarReporteEnPdf} from "../../../funciones_globales/interaccionApiReportes";
import {cargarCatalogosGenericoAsync} from "../../../funciones_globales/catalogos";
import {visualizarAlertaDeError, visualizarAlertaDeInforme} from '../../../actions/generales/act_gen01';
import {setClienteSeleccionado} from "../../../actions/clientes/act_cli01";
import ToggleSwitch from "@trendmicro/react-toggle-switch";
import {obtenerParametros, obtenerSecuencial} from "../../../funciones_globales/parametros";
import PickerFecha from "../../componentes_generales/componentes_formulario/datepicker/datepicker";
import moment from "moment";

const CODIGO_FORM = '0426';
const OPERACION_CREAR = 'G';
const OPERACION_MODIFICAR = 'M';

const COD_CARTON_MAX_LENGTH = 10;
const COD_CARTON_DEFAULT = 's/n';
const UNIDAD_MEDIDA = 'kg';

const defaultState = {
    operacion: OPERACION_CREAR,
    deshabilitarGuardado: false,
    pesoMaxCarton: 50,
    vistaDeItems: false
}

const initialState = {
    ...defaultState, capturaPesoAutoEnabled: true, ultimoEncartonado: '', teclaCapturaPesoCarton: 'F8'
}

class FormVen26 extends React.Component{

    constructor(props){
        super(props);
        this.state = initialState;

        this.limpiar = this.limpiar.bind(this);
        this.cargarEncartonadoById = this.cargarEncartonadoById.bind(this);
        this.cargarUltimoSecuencial = this.cargarUltimoSecuencial.bind(this);
    }

    componentDidMount(){

        Promise.all([
            obtenerParametros('PESOAUTOMATICO'),
            obtenerParametros('PESOMAXCARTON'),
            obtenerParametros('TECLAPESOCARTON'),
            this.cargarUltimoSecuencial(),
            this.props.generar_LogAuditoriaIngresoForm(CODIGO_FORM)
        ])
        .then(([parametroPesoAuto, parametroPesoMaxCarton, parametroTeclaPesoCarton])=>{

            try {
                this.setState({capturaPesoAutoEnabled: parametroPesoAuto[0].Habilitado === '1'});
            } catch (error) {
                alert('El parámetro PESOAUTOMATICO no pudo ser recuperado correctamente.');
            }

            try {
                this.setState({pesoMaxCarton: parseFloat(parametroPesoMaxCarton[0].PesoMax)});
            } catch (error) {
                alert('El parámetro PESOMAXCARTON no pudo ser recuperado correctamente.');
            }

            try {
                this.setState({teclaCapturaPesoCarton: parametroTeclaPesoCarton[0].Tecla});
            } catch (error) {
                alert('El parámetro TECLAPESOCARTON no pudo ser recuperado correctamente.');
            }

            let fechaProceso = moment(getFechaProcesoPorModulo('04'), 'DD/MM/YYYY');
            this.setState({fechaProceso});
            this.props.setEncartonadoFecha(fechaProceso);
        })
    }

    componentWillUnmount(){
        this.limpiar();
        this.props.generar_LogAuditoriaSalidaForm(CODIGO_FORM);
    }

    render(){
        const pesoInputStyle = {height: '24px', padding: '2px 5px', fontSize: '100%', lineHeight: '1.5', borderRadius: '2px'};
        const tdStyle = {padding: '0px 5px', margin: '0px'};

        return (
            <ContenedorForm porc_ancho={55}>
                <HeaderForm>
                    <TituloForm>Registro de Encartonado</TituloForm>
                    <span className='pull-right'>
                        <label style={{fontSize: '75%'}}>{`Últ. Encartonado: ${this.state.ultimoEncartonado}`}</label>
                        <label style={{fontSize: '75%', marginLeft: '30px'}}>Vista de items</label>
                        <ToggleSwitch
                            checked={this.state.vistaDeItems}
                            onChange={() => this.setState({ vistaDeItems: !this.state.vistaDeItems})}
                            size='sm'
                            style={{marginLeft: '5px'}}
                        />
                    </span>
                </HeaderForm>
                <CuerpoForm>
                    {!this.state.vistaDeItems && (
                        <div>
                            <Row>
                                <ContainerCol className='col-sm-2'>
                                    <LabelForm>Encartonado Id:</LabelForm>
                                    <InputSearch tipoInput='text' nombre='encartonadoId' placeholder='Encartonado Id'
                                                 maxLength={6} valor={this.props.encartonadoId}
                                                 func_CambiarValor={event=>this.props.setEncartonadoId(event.target.value)}
                                                 func_OnFocus={this.limpiar}
                                                 func_BuscarValor={()=>this.cargarEncartonadoById(this.props.encartonadoId)}/>
                                </ContainerCol>
                            </Row>
                            <hr style={{borderTop: '1px solid #cfd8dc', margin: '5px'}}/>
                            <Row>
                                <ContainerCol className='col-sm-7'>
                                    <label className='label-control'>Cliente:</label>
                                    <div className='input-group'>
                                        <ReactSelectAsync value={this.props.clienteSeleccionado} func_loadOptions={this.getOptions_Clientes}
                                              func_onChange={selectedClient => {
                                                  this.props.setClienteSeleccionado(this.mapClienteSeleccionado(selectedClient));
                                                  this.props.resetProformasAEncartonar();
                                                  this.props.resetItemsAEncartonar();
                                              }}/>
                                        <span className='input-group-addon' style={{padding: '0px 0px 0px 5px', border: 'none', backgroundColor: 'transparent'}}>
                                            <Tooltip placement='right' overlay='Buscar proformas para encartonar del cliente seleccionado.'>
                                                <button type='button' className='btn btn-default btn-sm'
                                                    onClick={()=>this.cargarProformasByClienteId()}>
                                                    <i className='fa fa-search'/>
                                                </button>
                                            </Tooltip>
                                        </span>
                                    </div>
                                </ContainerCol>
                                <ContainerCol className='col-sm-5'>
                                    <label className='label-control'>Fecha:</label>
                                    <PickerFecha fechaSeleccionada={this.props.encartonadoFecha} disabled={true}/>
                                </ContainerCol>
                            </Row>
                            <Row margen_abajo={10}>
                                <ContainerCol className='col-sm-7'>
                                    <LabelForm>Proformas a encartonar:</LabelForm>
                                    <div className='table-responsive' style={{fontSize: '75%'}}>
                                        <table className='table table-condensed table-bordered'>
                                            <thead>
                                                <tr>
                                                    <th className='text-center'>Proforma</th>
                                                    <th className='text-center'>Ped. Móvil</th>
                                                    <th className='text-center'>Cliente</th>
                                                    <th className='text-center'>Tipo</th>
                                                    <th/>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.props.proformasAEncartonar.map(proforma => (
                                                    <tr key={proforma.id}>
                                                        <td style={tdStyle}>{proforma.id}</td>
                                                        <td style={tdStyle}>{proforma.pedidoMovil}</td>
                                                        <td style={tdStyle}>{`${proforma.idCliente} - ${proforma.nombreCliente}`}</td>
                                                        <td style={tdStyle}>{proforma.tipo}</td>
                                                        <td style={tdStyle}>
                                                            <input type='checkbox' checked={proforma.esEncartonada}
                                                                   onChange={() => {
                                                                       this.props.cambiarEstadoDeProformaEncartonada(proforma.id, !proforma.esEncartonada);
                                                                       if(proforma.esEncartonada) {
                                                                           this.props.cargarItemsAEncartonarPorProforma(proforma.id);
                                                                       } else {
                                                                           this.props.eliminarItemsAEncartonarPorProforma(proforma.id);
                                                                       }
                                                                   }}/>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </ContainerCol>
                                <ContainerCol className='col-sm-5'>
                                    <label className='label-control'>Observación:</label>
                                    <textarea className='form-control' maxLength={250} rows='3' style={{resize: 'none', fontSize: '75%'}}
                                              value={this.props.encartonadoObservacion} onChange={event=>this.props.setEncartonadoObservacion(event.target.value)}/>
                                </ContainerCol>
                            </Row>
                        </div>)}
                    <Row margen_arriba={this.state.vistaDeItems?20:0}>
                        <ContainerCol className='col-sm-12'>
                            <TablaArticulos itemsEncartonado={this.props.itemsAEncartonar} codCartonMaxLength={COD_CARTON_MAX_LENGTH}
                                funcionValidacionDetalleCartonesPorItem={this.validarDetalleDeCartonesPorItem}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={10}>
                        {!this.state.vistaDeItems && (
                            <div className='col-sm-4' style={{maxWidth: '300px'}}>
                                <LabelForm>Resumen de cartones:</LabelForm>
                                <div className='table-responsive' style={{fontSize: '75%'}}>
                                    <table className='table table-condensed table-bordered'>
                                        <thead>
                                        <tr>
                                            <th className='text-center'>Cartón</th>
                                            <th className='text-center'>Unid.</th>
                                            <th className='text-center'>{`Peso (${UNIDAD_MEDIDA})`}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.props.resumenCartones.map((carton, i) => (
                                            <tr key={`carton-${i + 1}`}>
                                                <td>{carton.codCarton}</td>
                                                <td>{carton.unidades}</td>
                                                <td>
                                                    <input name='peso' type='text' value={carton.peso===null?'':carton.peso} autoComplete='off'
                                                           className='form-control' style={pesoInputStyle}
                                                           onChange={(event) => {
                                                               this.props.actualizarPesoDeCarton(carton.codCarton, event.target.value);
                                                           }}
                                                           onKeyDown={event => {
                                                               console.info(`Tecla Parametrizada para Capturar Peso: ${this.state.teclaCapturaPesoCarton} - Tecla Presionada: ${event.key}`)

                                                                /* Bloque de código para controlar que solo la <teclaCapturaPesoCarton> y <backspace> estén habilitadas
                                                                    let esTeclaPermitida = (event.key===this.state.teclaCapturaPesoCarton || event.key==='Backspace')
                                                                    console.info('Tecla presionada es permitida:', esTeclaPermitida)
                                                                    if (!esTeclaPermitida) event.preventDefault()
                                                                */

                                                               let esTeclaCapturaPesoAutomatico = event.key===this.state.teclaCapturaPesoCarton;
                                                               if (esTeclaCapturaPesoAutomatico) this.props.actualizarFlagPesoAutomatico(carton.codCarton, true);
                                                           }}
                                                           onFocus={ () => {
                                                               this.props.actualizarFlagPesoAutomatico(carton.codCarton, false);
                                                               this.props.actualizarPesoDeCarton(carton.codCarton, '');
                                                           }}

                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                        <div className={this.state.vistaDeItems?'col-sm-12':'col-sm-8'}>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-primary btn-sm' disabled={this.state.deshabilitarGuardado}
                                    onClick={()=>this.guardar(  this.state.operacion,
                                                                this.props.proformasAEncartonar.filter(proforma=>proforma.esEncartonada).map(proforma=>proforma.id),
                                                                this.props.itemsAEncartonar,
                                                                this.props.resumenCartones,
                                                                this.state.pesoMaxCarton)}>
                                    <i className='fa fa-floppy-o fa-lg'/> Guardar</button>
                                <button type='button' className='btn btn-info btn-sm' disabled={this.state.operacion===OPERACION_CREAR && !this.state.deshabilitarGuardado}
                                    onClick={()=>this.imprimir(this.props.encartonadoId)}><i className='fa fa-print fa-lg'/> Imprimir</button>
                                <button type='button' className='btn btn-danger btn-sm' disabled={this.state.operacion===OPERACION_CREAR && !this.state.deshabilitarGuardado}
                                    onClick={()=>this.anular(this.state.operacion, this.props.encartonadoId)}><i className='fa fa-window-close  fa-lg'/> Anular</button>
                                <button type='button' className='btn btn-sm' onClick={()=>this.limpiar()}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>
                            </div>
                        </div>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }

    getOptions_Clientes(input, callback){
        if (input.toString().length >= 3 ){
            let query = '?tipo=catalogo&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
    }

    mapClienteSeleccionado(clienteSeleccionado) {
        if(Array.isArray(clienteSeleccionado))
            return null;
        else
            return clienteSeleccionado;
    }

    cargarProformasByClienteId() {
        if(!validarJSON(this.props.clienteSeleccionado)){
            this.props.visualizarAlertaDeError('Campos incompletos', 'Debe especificar el cliente que desea consultar.');
        } else {
            const clienteId = this.props.clienteSeleccionado.value;
            this.props.cargarProformasAEncartonarPorCliente(clienteId);
        }
    }

    validarDetalleDeCartonesPorItem = (detalleCartonesDelItem, totalUnidadesDelItem) => {
        let errores = [];
        if (detalleCartonesDelItem.length > 0) {
            if (detalleCartonesDelItem.filter(carton => !validarCampoString(carton.codCarton, 1, COD_CARTON_MAX_LENGTH)).length > 0) {
                errores.push('Código(s) incompleto(s)');
            }

            let totalDesgloseCartones = detalleCartonesDelItem.map(carton => esNumero(carton.cantidad) ? parseFloat(carton.cantidad) : 0)
                .reduce((total, value) => total + value, 0);
            if (totalDesgloseCartones !== totalUnidadesDelItem) {
                errores.push('Desglose no cuadra con cant. item');
            }
        } else {
            errores.push('No ha ingresado cartones');
        }
        return errores;
    }

    validarItemsAEncartonar(items) {
        let itemsConErrores = [];
        items.forEach((item, i) => {
            let errores = this.validarDetalleDeCartonesPorItem(item.detalleCartones, item.cantidadDespacho);
            if(errores.length>0) {
                this.props.actualizarErroresDeValidacionDeItem(item.idItem, errores);
                itemsConErrores.push(i+1);
            }
        })
        return itemsConErrores;
    }

    validarResumenCartones(cartones, pesoMaximoCarton, permitirCartonesSinPeso) {
        let cartonesConErrores = [];
        cartones.forEach(carton => {
            const codigoCarton = carton.codCarton.length===0? COD_CARTON_DEFAULT : carton.codCarton;
            const pesoCarton = carton.peso===null?'':carton.peso.toString().trim();
            const capturaAutomatica = carton.capturaAutomatica===true;

            if(pesoCarton.length===0 && !permitirCartonesSinPeso) {
                cartonesConErrores.push(`Cartón ${codigoCarton} no tiene peso`);
            }
            if(pesoCarton.length>0) {
               if(esNumero(pesoCarton)) {
                   if(parseFloat(pesoCarton)>pesoMaximoCarton) {
                       cartonesConErrores.push(`Cartón ${codigoCarton} tiene peso mayor al máximo permitido: ${pesoMaximoCarton} ${UNIDAD_MEDIDA}`);
                   }
                   if (this.state.capturaPesoAutoEnabled && !capturaAutomatica) {
                       cartonesConErrores.push(`Cartón ${codigoCarton} no registra peso automático`);
                   }
               }else{
                   cartonesConErrores.push(`Cartón ${codigoCarton} no tiene peso válido`);
               }
            }
        });
        return cartonesConErrores;
    }

    guardar(operacion, proformas, items, cartones, pesoMaxCarton) {

        let camposPendientes = [];

        if(!validarJSON(this.props.clienteSeleccionado)){
            camposPendientes.push('Cliente');
        }

        if(items.length === 0){
            camposPendientes.push('Items a encartonar');
        }

        let itemsConErroresDeDetalleCartones = this.validarItemsAEncartonar(items);
        if(itemsConErroresDeDetalleCartones.length>0) {
            camposPendientes.push(`Detalle de cartones en los items: ${itemsConErroresDeDetalleCartones.join(', ')}`);
        }

        let cartonesConErrores = this.validarResumenCartones(cartones, pesoMaxCarton, operacion===OPERACION_CREAR);
        if(cartonesConErrores.length>0) {
            camposPendientes.push(cartonesConErrores.join(', '));
        }

        if(camposPendientes.length>0) {
            this.props.visualizarAlertaDeError('Campos inválidos', `Los siguientes campos no fueron ingresados correctamente: ${camposPendientes.join('; ')}.`);
        }else {

            if(this.state.operacion===OPERACION_MODIFICAR){
                if (this.state.fechaProceso.diff(this.props.encartonadoFecha, 'days')>0){
                    this.props.visualizarAlertaDeError('Acción inválida', `No se permite modificar encartonados que tienen fecha anterior a la fecha de proceso: ${this.state.fechaProceso.format('DD/MM/YYYY')}.`);
                    return;
                }
            }
            
            const clienteId = this.props.clienteSeleccionado.value;

            let encartonado = {
                id: this.props.encartonadoId,
                clienteId,
                fecha: getFechaProcesoPorModulo('04'),
                usuario: getItemDatosSesion('usuario'),
                nroCartones: cartones.length,
                pesoTotal: cartones.map(carton => esNumero(carton.peso) ? parseFloat(carton.peso) : 0).reduce((total, pesoCarton) => total + pesoCarton, 0),
                unidMedida: UNIDAD_MEDIDA,
                observacion: this.props.encartonadoObservacion,
                proformas,
                cartones: cartones.map(carton => ({codCarton: carton.codCarton, unidades: carton.unidades, peso: esNumero(carton.peso)? parseFloat(carton.peso): null})),
                detalleItems: items.map(item => ({
                    pedidoMovil: item.pedMovil,
                    proforma: item.proforma,
                    articulo: item.articulo,
                    cantDespacho: item.cantidadDespacho,
                    detalleCartones: item.detalleCartones.map(carton => `${carton.codCarton.trim()}:${carton.cantidad}`).join('&')
                }))
            };
            this.props.guardarEncartonado(operacion, encartonado, ()=>this.setState({deshabilitarGuardado: true}));
        }
    }

    cargarUltimoSecuencial() {
        obtenerSecuencial('Encartonado').then(secuencialEncartonado => {
            if (secuencialEncartonado.codigo) {
                this.setState({ultimoEncartonado: secuencialEncartonado.codigo === 1 ? 1 : secuencialEncartonado.codigo - 1});
            }
        });
    }

    limpiar() {
        this.setState(defaultState);
        this.props.setEncartonadoId('');
        this.props.setEncartonadoObservacion('');
        this.props.setEncartonadoFecha(this.state.fechaProceso);
        this.props.actualizarCodUltimoCarton('');
        this.props.setClienteSeleccionado(null);
        this.props.resetProformasAEncartonar();
        this.props.resetItemsAEncartonar();
        this.cargarUltimoSecuencial();
    }

    cargarEncartonadoById(idEncartonado) {
        if(!validarStringConAnchoMinimo(idEncartonado, 1)){
            this.props.visualizarAlertaDeError('Campos incompletos', 'Debe especificar el encartonado que desea consultar.')
        } else {
            this.props.cargarEncartonado(idEncartonado, () => {
                this.setState({operacion: OPERACION_MODIFICAR})
                this.cargarProformasByClienteId();
            });
        }
    }

    imprimir(idEncartonado) {
        if(!validarStringConAnchoMinimo(idEncartonado, 1)){
            this.props.visualizarAlertaDeError('Campos incompletos', 'Debe especificar el encartonado que desea imprimir.')
        } else {
            visualizarReporteEnPdf('&rpt=146&param1=' + idEncartonado);
        }
    }

    anular(modoOperacionActual, idEncartonado) {
        if(!validarStringConAnchoMinimo(idEncartonado, 1)){
            this.props.visualizarAlertaDeError('Campos incompletos', 'Debe especificar el encartonado que desea anular.');
            return;
        }

        let permiso = validarPermisoAcceso(modoOperacionActual, this.props.permiso);
        if (!permiso.esValido){
            this.props.visualizarAlertaDeError('Permiso denegado', permiso.msg);
            return;
        }

        if(!window.confirm(`¿Está seguro de anular el Encartonado No.: ${idEncartonado}?`)){
            return;
        }

        this.props.anularEncartonado(idEncartonado, this.props.idRegAudit, ()=>this.limpiar());
    }
} 

const mapStateToProps = (state => {
    return {    permiso: state.sesion.valoresSesionForm.Permiso,
                idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
                proformasAEncartonar: state.ventas.proformasAEncartonar,
                itemsAEncartonar: state.ventas.itemsAEncartonar,
                resumenCartones: state.ventas.resumenCartones,
                clienteSeleccionado: state.clientes.clienteSel,
                encartonadoId: state.ventas.encartonadoId,
                encartonadoObservacion: state.ventas.encartonadoObservacion,
                encartonadoFecha: state.ventas.encartonadoFecha
    };
});

const mapDispatchToProps = (dispatch => {
    return bindActionCreators({ generar_LogAuditoriaIngresoForm,
                                            generar_LogAuditoriaSalidaForm,
                                            cambiar_VisualizacionLoading,
                                            visualizarAlertaDeError,
                                            visualizarAlertaDeInforme,
                                            setClienteSeleccionado,
                                            cargarProformasAEncartonarPorCliente,
                                            cambiarEstadoDeProformaEncartonada,
                                            resetProformasAEncartonar,
                                            cargarItemsAEncartonarPorProforma,
                                            eliminarItemsAEncartonarPorProforma,
                                            actualizarErroresDeValidacionDeItem,
                                            resetItemsAEncartonar,
                                            actualizarPesoDeCarton,
                                            actualizarFlagPesoAutomatico,
                                            actualizarCodUltimoCarton,
                                            guardarEncartonado,
                                            cargarEncartonado,
                                            anularEncartonado,
                                            setEncartonadoId,
                                            setEncartonadoObservacion,
                                            setEncartonadoFecha
                                        }, dispatch);
});

export default connect(mapStateToProps, mapDispatchToProps)(FormVen26);